export const START_FETCHING_EXTENSIONS = 'START_FETCHING_EXTENSIONS';
export const STOP_FETCHING_EXTENSIONS = 'STOP_FETCHING_EXTENSIONS';
export const FETCHED_EXTENSIONS = 'FETCHED_EXTENSIONS';
